import {Repository, RequestMethod} from 'b302-frontend-library';

class FavoritesRepository extends Repository {

    public constructor() {
        super('/favorites');
    }

    public all() {
        return this.request<number[]>(this.url(), RequestMethod.GET).sendRaw();
    }

    public toggleFavorite(university: number) {
        return this.request<number[]>(this.url('/toggle-favorite'), RequestMethod.POST,{ university }).sendRaw();
    }
}

export default FavoritesRepository;
